import { HtmlRenderer, Parser } from 'commonmark';
import * as React from 'react';
import { Link } from 'react-router';

import CompetencesContentPage from '../../api/competencesPageEntity';
import LinkItem from '../../api/linkItemEntity';

import { BreadcrumbContainer } from '../../common/components/breadcrumb/breadcrumbContainer';

interface IProps {
  competencesContentPage: CompetencesContentPage;
  /** Redux‑injected thunk that loads the data for this page */
  fetchCompetencesPage(): void;
}

/**
 * Competences landing page.
 * Defensive‑coding: render a loading skeleton until CMS data arrives and
 * guard all optional props so runtime never crashes when editors leave a
 * field empty or the entry uses a different content model.
 */
export class CompetencesPage extends React.Component<IProps, {}> {
  public componentDidMount() {
    this.props.fetchCompetencesPage();
  }

  public render() {
    const page = this.props.competencesContentPage;

    // ────────── 1. fast‑exit while loading ──────────
    if (!page || !page.content) {
      return (
        <main className="contentpage is-loading">
          <div className="container">
            <BreadcrumbContainer />
            <p>Ladataan sisältöä…</p>
          </div>
        </main>
      );
    }

    // ────────── 2. safe markdown parsing ──────────
    const parser = new Parser();
    const renderer = new HtmlRenderer();
    const contentHtml = renderer.render(parser.parse(page.content));

    // Arrays may be undefined -> default to []
    const plannerLinks = page.plannerLinkList || [];
    const supervisorLinks = page.supervisorLinkList || [];
    const linkItems = page.linkItems || [];

    return (
      <main className="contentpage">
        <div className="container">
          <BreadcrumbContainer />

          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="content">
                {page.heroImage && (
                  <img src={page.heroImage} className="content-hero-img" />
                )}
                <h1>{page.title || 'Pätevyydet'}</h1>
                {/* eslint-disable-next-line react/no-danger */}
                <p dangerouslySetInnerHTML={{ __html: contentHtml }} />
              </div>

              {/* Planner & Supervisor lists */}
              <br />
              <br />
              <div className="certs">
                <div className="row">
                  <div className="col-md-6 col-sm-12 ">
                    <h3>Suunnittelijat</h3>
                    <ul className="listing">
                      {plannerLinks.map(renderLinkItem)}
                    </ul>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <h3>Työnjohtajat</h3>
                    <ul className="listing">
                      {supervisorLinks.map(renderLinkItem)}
                    </ul>
                  </div>
                </div>

                {/* Fallback arrays keep slice() safe */}
                <div className="row link-blocks">
                  {linkItems.slice(0, 3).map(renderLinkBox)}
                </div>
                <div className="row link-blocks">
                  {linkItems.slice(3, 6).map(renderLinkBox)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

// ---------------------------------------------------------------------------
// Helper renderers
// ---------------------------------------------------------------------------
function renderLinkBox(linkItem: LinkItem) {
  if (!linkItem) {
    return null;
  }

  const inner = (
    <>
      <h3>{linkItem.title}</h3>
      <span>{linkItem.description}</span>
    </>
  );

  if (linkItem.url && linkItem.url.startsWith('http')) {
    return (
      <div className="col-md-4" key={linkItem.id}>
        <a href={linkItem.url} target={linkItem.urlTarget} className="link-block">
          {inner}
        </a>
      </div>
    );
  } else {
    return (
      <div className="col-md-4" key={linkItem.id}>
        <Link to={linkItem.url} className="link-block">
          {inner}
        </Link>
      </div>
    );
  }
}

function renderLinkItem(linkItem: LinkItem) {
  if (!linkItem) {
    return null;
  }

  return (
    <li key={linkItem.id}>
      <Link to={linkItem.url} target={linkItem.urlTarget} className="box-inner-wrap">
        {linkItem.title}
      </Link>
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/components/competencesPage/competencesPage.tsx